import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ProjectStepperService } from '@shared';

export const stepperDeactivateGuard: CanDeactivateFn<unknown> = () => {
  const stepper = inject(ProjectStepperService);
  if (stepper.isOpen() && stepper.step4EditDirty()) {
    return window.confirm('You have unsaved floor plan edits. Leave and discard them?');
  }
  return true;
};
